import { writable } from "svelte/store";

export const selectedAccount = writable("");
